import { Phone } from 'lucide-react';

/**
 * PriceDisplay — three states:
 *   1) priceOnRequest = true  → neutral "Contact for price" pill (NOT yellow)
 *   2) hasDiscount = true     → strikethrough + salePrice + discount%
 *   3) normal                  → price + AED
 */
export default function PriceDisplay({ item = {}, locale = 'ar', size = 'md' }) {
  const isAr = locale === 'ar';
  const fmt = (n) => Number(n || 0).toLocaleString('en-US');

  const price     = item.salePrice || item.rent_price || item.price;
  const original  = item.originalPrice || item.price;
  const hasSale   = !!(item.hasDiscount && item.salePrice && item.salePrice < original);
  const pct       = item.discountPercentage || (hasSale ? Math.round(((original - item.salePrice) / original) * 100) : null);

  // Font sizing per usage context
  const priceCls = size === 'lg' ? 'text-3xl font-bold' : size === 'sm' ? 'text-base font-semibold' : 'text-xl font-bold';
  const currCls  = size === 'lg' ? 'text-lg' : size === 'sm' ? 'text-xs' : 'text-sm';

  // 1) Contact for price
  if (item.priceOnRequest) {
    return (
      <span
        data-testid="price-on-request"
        className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-semibold border whitespace-nowrap
                   bg-slate-50 text-slate-700 border-slate-300
                   dark:bg-white/5 dark:text-white/90 dark:border-white/15"
      >
        <Phone className="h-3.5 w-3.5" />
        {isAr ? 'التواصل لمعرفة السعر' : 'Contact for price'}
      </span>
    );
  }

  // 2) Discount
  if (hasSale) {
    return (
      <div className="flex items-center gap-2 flex-wrap" data-testid="price-discount">
        {pct != null && (
          <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-bold bg-red-500 text-white">
            -{pct}%
          </span>
        )}
        <span className={`${priceCls} text-[#1E9BD9] dark:text-white`} dir="ltr">
          {fmt(item.salePrice)}
        </span>
        <span className={`${currCls} font-semibold text-[#1E9BD9] dark:text-white`}>AED</span>
        <span className={`text-sm text-slate-400 line-through`} dir="ltr">
          {fmt(original)}
        </span>
      </div>
    );
  }

  // 3) Normal
  if (price == null) {
    return <span className="text-sm text-slate-400">—</span>;
  }
  return (
    <div className="flex items-center gap-2" data-testid="price">
      <span className={`${priceCls} text-[#0F172A] dark:text-white`} dir="ltr">
        {fmt(price)}
      </span>
      <span className={`${currCls} font-semibold text-[#1E9BD9]`}>AED</span>
      {item.rent_frequency && (
        <span className="text-xs text-slate-500">/ {isAr ? (item.rent_frequency === 'yearly' ? 'سنوياً' : 'شهرياً') : item.rent_frequency}</span>
      )}
    </div>
  );
}
